const format = (n: number) => (n % 1 === 0 ? n.toFixed(0) : n.toFixed(1));

export const formatNumber = (num: number): string => {
  if (num >= 1000000) {
    return `${format(num / 1000000)}M`;
  }
  if (num >= 1000) {
    return `${format(num / 1000)}k`;
  }
  return num.toString();
};
